import React from 'react';
import placeholderPoster from '../../assets/placeholder-poster.png';

const MovieCard = ({ movie, onClick }) => {
  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.classList.add('poster-placeholder');
    e.target.src = placeholderPoster;
  };

  return (
    <div
      className="movie-card"
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <div className="poster-wrapper">
        <img
          src={movie.posterUrl || placeholderPoster}
          alt={`${movie.name} poster`}
          className="movie-poster"
          loading="lazy"
          onError={handleImageError}
        />
      </div>
      <div className="movie-info">
        <h2>{movie.name}</h2>
        <div className="movie-meta">
          <span className="year">{movie.yearRange}</span>
          <span className="rating">IMDB: {movie.imdb}</span>
        </div>
        <p className="description">{movie.description}</p>
      </div>
    </div>
  );
};

export default MovieCard; 